import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from 'cre-ng';

import { Tractor } from '@app/core/driver-wig.model';
import { IDriverVOTService } from '../interface/IDriverVOTService';

@Injectable()
export class DriverVOT extends BaseService implements IDriverVOTService {
  constructor(protected httpClient: HttpClient) {
    super({ serviceApiDomain: window.__env.ngSettings.serviceApiDomain }, httpClient);
  }

  getTractorsByDriverId(driverId: string): Promise<Tractor[]> {
    const httpHeaders = this.getHttpHeaders();
    const body = {
      pathVariables: [
        {
          name: 'filter',
          value: driverId + '?retrieveRealTimeData=true',
        },
      ],
      requestBody: '',
      requestParameters: [],
    };
    const requestOptions = { headers: httpHeaders };
    return this.httpClient
      .post<Tractor[]>(this.serviceUrl + '/confidenceFindTractor', body, requestOptions)
      .toPromise();
  }

  protected getEndPoint(): string {
    return '/apisecurity/api/v1/preauth/drivervot';
  }
}
